/* eslint no-nested-ternary: "off" */
import React, { useState, useContext, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { uniq } from "lodash";
import DetailsLoader from "components/ContentLoader";
import Map from "components/Map";
import {
  addTextChangeDebounce,
  getUserTwitterDomain,
  parseFieldArea,
} from "utils";
import CustomModal from "components/Modal";
import Button from "components/Button";
import Loading from "components/Loading";
import { UserContext } from "context/user";
import { getFarms, getFields } from "api/Farm";
import { getProducts } from "api/Products";
import { getOrderQuote, createOrder } from "api/Orders";
import {
  createContactDetails,
  getContactDetails,
  updateContactDetails,
} from "api/User";
import appLogo from "assets/logo/logo-only.png";
import InputField from "components/Input";
import RadioButton from "components/Radio";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { add, format } from "date-fns";
import ricePhoto from "assets/images/high-res/rice.png";
import vineyardPhoto from "assets/images/high-res/vineyard.png";
import eightyCMPhoto from "assets/images/high-res/general.png";
import treesPhoto from "assets/images/high-res/trees.png";
import horticulturePhoto from "assets/images/high-res/horticulture.png";
import golfPhoto from "assets/images/high-res/golf.png";
import broadacrePhoto from "assets/images/high-res/broadacre.png";
import CheckBox from "components/CheckBox";
import HighResTerms from "assets/images/datafarming-hr-imagery-terms.pdf";
import AddressFields from "components/AddressFields";
import { CheckCircle, FrameCorners, Tag } from "phosphor-react";
import "./index.scss";
import { SUCCESS_STATUS } from "constants/success-status";

const OrderHighResContainer = () => {
  const { token, profile } = useContext(UserContext);
  const history = useHistory();
  const [steps] = useState([
    "selectFarmAndFields",
    "selectProduct",
    "selectDateRange",
    "orderConfirmation",
    "paymentInformation",
  ]);
  const [payment, setPayment] = useState("Credit or Debit Card");
  const [currentStep, setCurrentStep] = useState("selectFarmAndFields");
  const [selectedFarmModal, setSelectedFarmModal] = useState(null);
  const [farmsModalOpen, setFarmsModalOpen] = useState(false);
  const [learnMoreModalOpen, setLearnMoreModalOpen] = useState(false);
  const [learnMoreContent, setLearnMoreContent] = useState(null);
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageSize, setPageSize] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [selectedFarms, setSelectedFarms] = useState([]);
  const [selectedFarmToEdit, setSelectedFarmToEdit] = useState(null);
  const [products, setProducts] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [checkedFarms, setCheckedFarms] = useState([]);
  const [captures, setCaptures] = useState(3);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("stripe");
  const [editState, setEditState] = useState(false);
  const [orderQuotation, setOrderQuotation] = useState([]);
  const [totalHa, setTotalHa] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [country, setCountry] = useState("");
  const [emailDomain, setEmailDomain] = useState("");
  const [numOfCaptures, setNumOfCaptures] = useState("");
  const [formValues, setFormValues] = useState({
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
    state: "",
  });
  const [userDetails, setUserDetails] = useState(null);
  const [selectedFieldsTotalHa, setSelectedFieldsTotalHa] = useState("");
  const [formType, setFormType] = useState("");

  const handleSelectCountry = (val) => {
    setCountry(val.toUpperCase());
  };

  const handleAgreeTerms = () => {
    setAgreeTerms(!agreeTerms);
  };

  const formatStartDate = startDate
    ? format(new Date(startDate), "dd MMM yyyy")
    : "";
  const formatEndDate = endDate ? format(new Date(endDate), "dd MMM yyyy") : "";

  const getQuote = useCallback(async () => {
    setLoading(true);
    const fieldIds = selectedFields.map((field) => field.properties.id);

    const data = {
      data: {
        product_id: selectedProduct?.id,
        field_ids: fieldIds,
        number_of_captures:
          selectedProduct?.title === "50 cm Resolution Imagery"
            ? selectedProduct?.config?.captures[numOfCaptures]
                .number_of_captures
            : captures,
      },
    };
    const orderQoute = await getOrderQuote(data, token);
    setLoading(false);
    setOrderQuotation(orderQoute.data);
    const formatTotalPrice = orderQoute.data
      ? orderQoute.data?.order_pricing?.subtotal / 100
      : 0;
    const formatTotalHa = orderQoute.data
      ? orderQoute.data?.total_product_unit
      : 0;
    if (selectedProduct.title === "Golf & Park") {
      setTotalPrice(selectedProduct.config?.captures[0].min_price);
    } else {
      setTotalPrice(formatTotalPrice);
    }
    setTotalHa(formatTotalHa);
  }, [token, selectedFields, captures, selectedProduct, numOfCaptures]);

  const fetchUserData = useCallback(async () => {
    if (!token) return;

    const userDetailsData = await getContactDetails(token);
    setUserDetails(userDetailsData.data);
    if (userDetailsData.data.email) {
      const userDomain = getUserTwitterDomain(userDetailsData.data.email);
      setEmailDomain(userDomain);
    }
  }, [token]);

  const getSelectedFieldsTotaArea = useCallback(() => {
    if (!selectedFields.length) return;
    let totalArea = 0;

    selectedFields.map((fields) => {
      const { area } = fields.properties;
      totalArea += area;
      return totalArea;
    });
    setSelectedFieldsTotalHa(totalArea);
  }, [selectedFields]);

  useEffect(() => {
    if (selectedFields.length) {
      getSelectedFieldsTotaArea();
    } else {
      setSelectedFieldsTotalHa(0);
    }
  }, [getSelectedFieldsTotaArea, selectedFields.length]);

  useEffect(() => {
    if (currentStep === "selectProduct" && selectedProduct) {
      getQuote();
    }
  }, [currentStep, selectedProduct, getQuote]);

  useEffect(() => {
    const fetchProducts = async () => {
      const productsData = await getProducts(token);
      const productList = productsData.data.filter(
        (product) => product.enabled === true
      );
      setProducts(productList.sort((a, b) => a.title.localeCompare(b.title)));
    };

    if (currentStep === "selectProduct" && !products.length) {
      fetchProducts();
    }
  }, [currentStep, products, token]);

  useEffect(() => {
    if (userDetails) {
      setFormValues({
        zipCode: userDetails?.post_code || "",
        address1: userDetails?.address1 || "",
        address2: userDetails?.address2 || "",
        city: userDetails?.city || "",
        state: userDetails?.state || "",
      });
      setCountry(userDetails?.country || "");
      setFirstName(userDetails?.first_name || "");
      setLastName(userDetails?.last_name || "");
      if (emailDomain === "twitter.df") {
        setEmail("");
      } else {
        setEmail(userDetails?.email || "");
      }
      setNumber(userDetails?.phone_number || "");
      setFormType("update");
    } else {
      setFormType("add");
    }
  }, [userDetails, emailDomain]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const fetchData = useCallback(
    async ({ pageSize, pageIndex }) => {
      if (token) {
        const limit = pageSize;
        const skip = pageSize * pageIndex;
        setLoading(true);
        try {
          let query = `skip=${skip}&limit=${limit}`;

          if (searchValue) {
            query += `&search_query=${searchValue.toLowerCase()}`;
          }
          const farmsData = await getFarms(query, token);
          setFarms(farmsData.features);
          setPageCount(farmsData.pages.total_pages);
        } catch (e) {
          toast.error(e);
        }
        setLoading(false);
      }
    },
    [searchValue, token]
  );

  useEffect(() => {
    if (fetchData) {
      fetchData({ pageIndex: currentPage, pageSize: currentPageSize });
    }
    return null;
  }, [fetchData, currentPage, currentPageSize]);

  useEffect(() => {
    const customDate = new Date();
    const customYear = customDate.getFullYear() + 1;
    const customStartDate = new Date(`11-15-${customDate.getFullYear()}`);
    const customEndDate = new Date(`01-15-${customYear}`);
    if (selectedProduct?.title === "2.5m Resolution Imagery") {
      setStartDate(customStartDate);
      setEndDate(customEndDate);
    }
  }, [selectedProduct, currentStep, steps]);

  const openFarmsModal = async () => {
    fetchData({ pageSize: currentPageSize, pageIndex: currentPage });
    setFarmsModalOpen(true);
    setCheckedFarms([]);
  };

  useEffect(() => {
    if (totalPrice === 0) {
      setPayment("Invoice");
      setPaymentMethod("invoice");
    }
  }, [totalPrice]);

  const handleSelectFarm = async () => {
    const fieldsData = await getFields(
      selectedFarmModal.properties.farm_id,
      token
    );
    const newFarm = selectedFarmModal;
    newFarm.fields = fieldsData.features;
    setSelectedFarms((previousFarms) => [...previousFarms, newFarm]);
    setSelectedFarmModal(null);
    setFarmsModalOpen(false);
    setSelectedFarmToEdit([newFarm]);
  };

  const handlePaymentMethod = (e) => {
    if (e.target.id && e.target.id === "invoice") {
      setPayment("Invoice");
      setPaymentMethod(e.target.id);
    }
    if (e.target.id && e.target.id === "stripe") {
      setPayment("Credit or Debit Card");
      setPaymentMethod(e.target.id);
    }
  };

  const handleStep = () => {
    if (
      selectedProduct?.title === "2.5m Resolution Imagery" &&
      currentStep === "orderConfirmation"
    ) {
      setCurrentStep(steps[steps.indexOf(currentStep) - 2]);
    } else {
      setCurrentStep(steps[steps.indexOf(currentStep) - 1]);
    }
    setAgreeTerms(false);
  };

  const handleRemoveSelectedFarm = (farm) => {
    const updatedFarms = selectedFarms.filter(
      (item) => item.properties.farm_id !== farm.properties.farm_id
    );
    const selectedFarmFieldIds = farm.fields?.map((field) => field?.id);
    setSelectedFields((oldFields) =>
      oldFields.filter(
        (oldField) => !selectedFarmFieldIds.includes(oldField?.id)
      )
    );
    setSelectedFarms(updatedFarms);
  };

  const handleSearchFarm = (search) => {
    addTextChangeDebounce(() => setSearchValue(search));
  };

  const addFarmsModal = async () => {
    setCurrentPage(0);
    setSearchValue("");
    fetchData({ pageSize: currentPageSize, pageIndex: 0 });
    setFarmsModalOpen(true);
    setCheckedFarms([]);
  };

  const handleSelectProduct = (prod) => {
    setSelectedProduct(prod);
    setStartDate(null);
    setEndDate(null);
    if (
      Array.isArray(prod?.config?.captures) &&
      selectedProduct?.id !== prod?.id
    ) {
      if (prod?.title === "50 cm Resolution Imagery") {
        setNumOfCaptures(1);
      } else {
        setCaptures(prod?.config?.captures[0]?.number_of_captures);
        setNumOfCaptures(0);
      }
    }
  };

  const handleSelectCaptures = (e, prod) => {
    e.stopPropagation();
    const selectedValue = parseFloat(e.target.value);
    handleSelectProduct(prod);
    if (selectedProduct?.id !== prod?.id) {
      setSelectedProduct(prod);
    }
    setCaptures(prod?.config?.captures[selectedValue]?.number_of_captures);
    setNumOfCaptures(selectedValue);
  };

  const handleCheckedFarms = (data) => {
    let newSelectedFarm;
    if (checkedFarms.includes(data.properties.farm_id)) {
      newSelectedFarm = checkedFarms.filter(
        (id) => id !== data.properties.farm_id
      );
    } else if (checkedFarms.length > 0) {
      newSelectedFarm = [data.properties.farm_id];
    } else {
      newSelectedFarm = [...checkedFarms, data.properties.farm_id];
    }
    setCheckedFarms(newSelectedFarm);
    if (newSelectedFarm.length > 0) {
      setSelectedFarmModal(data);
    } else {
      setSelectedFarmModal(null);
    }
  };

  React.useMemo(() => {
    addTextChangeDebounce(() => {
      if (currentStep === "orderConfirmation" && selectedFields) {
        getQuote();
      }
    });
  }, [selectedFields, currentStep, getQuote]);

  const handleCheckedFields = (fieldSelected) => {
    let newSelectedFields;

    if (selectedFields.includes(fieldSelected)) {
      newSelectedFields = selectedFields.filter(
        (selectedField) => selectedField !== fieldSelected
      );
    } else {
      newSelectedFields = [...selectedFields, fieldSelected];
    }
    setSelectedFields(newSelectedFields);
  };

  const getFieldCount = (farm) => {
    let fieldCount = 0;
    selectedFields?.map((field) => {
      return farm?.fields?.map((item) => {
        if (field.id === item.id) {
          fieldCount += 1;
        }
        return fieldCount;
      });
    });
    return { fieldCount, farmName: farm?.properties?.farm_name };
  };

  const handleNextButton = () => {
    const noSelectedFieldsCount = [];
    if (currentStep === "selectFarmAndFields" && !selectedFarms.length) {
      toast.error("No Farms selected.");
    }
    if (currentStep === "selectFarmAndFields" && !selectedFields.length) {
      toast.error("No Fields selected.");
    }
    if (
      currentStep === "selectFarmAndFields" &&
      selectedFarms.length &&
      selectedFields.length
    ) {
      selectedFarms?.map((farm) => {
        const { fieldCount, farmName } = getFieldCount(farm);
        if (fieldCount === 0) {
          noSelectedFieldsCount.push(farmName);
        }
        return noSelectedFieldsCount;
      });
      if (noSelectedFieldsCount) {
        noSelectedFieldsCount.forEach((farm) => {
          toast.error(`Select atleast 1 field on ${farm}`);
        });
      }
    }

    if (
      currentStep === "selectFarmAndFields" &&
      selectedFarms.length &&
      selectedFields.length &&
      !noSelectedFieldsCount.length
    ) {
      setCurrentStep(steps[steps.indexOf(currentStep) + 1]);
    }
    if (currentStep === "selectProduct" && selectedProduct === null) {
      toast.error("No Products selected.");
    }
    if (
      currentStep === "selectProduct" &&
      Object.keys(selectedProduct).length > 0 &&
      selectedProduct.title !== "2.5m Resolution Imagery"
    ) {
      setCurrentStep(steps[steps.indexOf(currentStep) + 1]);
    }
    if (
      currentStep === "selectProduct" &&
      Object.keys(selectedProduct).length > 0 &&
      selectedProduct.title === "2.5m Resolution Imagery"
    ) {
      setCurrentStep(steps[steps.indexOf(currentStep) + 2]);
    }
    if (
      currentStep === "selectDateRange" &&
      startDate === "" &&
      endDate === ""
    ) {
      toast.error("No Date range selected.");
    }
    if (currentStep === "selectDateRange" && startDate && endDate) {
      setCurrentStep(steps[steps.indexOf(currentStep) + 1]);
    }
    if (currentStep === "orderConfirmation" && !selectedFarms.length) {
      toast.error("Cart is Empty.");
    }
    if (currentStep === "orderConfirmation" && selectedFarms.length) {
      getQuote();
      setCurrentStep(steps[steps.indexOf(currentStep) + 1]);
    }

    if (
      currentStep === "paymentInformation" &&
      (firstName === "" ||
        lastName === "" ||
        email === "" ||
        number === "" ||
        formValues.address1 === "" ||
        country === "" ||
        formValues.city === "" ||
        formValues.state === "" ||
        formValues.zipCode === "" ||
        paymentMethod === "")
    ) {
      toast.error("Fields are empty.");
    }
  };

  const handleSelectStartDate = (date) => {
    setStartDate(date);
    setEndDate(null);
  };

  const handleSelectEndDate = (date) => {
    setEndDate(date);
  };

  const handleEditState = (farm) => {
    setEditState(!editState);
    const updatedFarms = selectedFarms.filter(
      (item) => item.properties.farm_id === farm.properties.farm_id
    );
    setSelectedFarmToEdit(updatedFarms);
  };

  const handleSubmitOrder = async () => {
    const fieldIds = selectedFields.map((field) => field.properties.id);
    setLoading(true);
    const validEmail = /\S+@\S+\.\S+/;
    if (
      firstName === "" ||
      lastName === "" ||
      number === "" ||
      formValues.streetAddress === "" ||
      country === "" ||
      formValues.city === "" ||
      formValues.state === "" ||
      formValues.zipCode === "" ||
      paymentMethod === ""
    ) {
      toast.error("Fields are empty.");
      setLoading(false);
    } else if (!validEmail.test(email) || email === "") {
      toast.error("Invalid Email Address");
      setLoading(false);
    } else {
      const data = {
        data: {
          product_id: selectedProduct.id,
          start_capture_date: startDate,
          end_capture_date: endDate,
          total_product_unit: 0,
          order_total: 0,
          order_subtotal: 0,
          gst: 0,
          first_name: firstName,
          last_name: lastName,
          phone_number: number,
          address1: formValues.address1,
          address2: formValues.address2,
          suburb: formValues.city,
          street: formValues.address1,
          state: formValues.state,
          city: formValues.city,
          country,
          post_code: formValues.zipCode,
          field_ids: fieldIds,
          number_of_captures: captures,
          payment_method: paymentMethod,
        },
      };

      const userParams = {
        data: {
          post_code: formValues.zipCode,
          address1: formValues?.address1,
          address2: formValues?.address2,
          city: formValues?.city,
          state: formValues?.state,
          country,
          first_name: firstName,
          last_name: lastName,
          email,
          user_type: userDetails?.user_type || "other",
          phone_number: number,
          company: companyName,
        },
      };
      let response = {};

      try {
        if (formType === "add") {
          response = await createContactDetails(userParams, token);
        } else {
          response = await updateContactDetails(userParams, token);
        }

        if (SUCCESS_STATUS.includes(response.status)) {
          const userOrder = await createOrder(data, token);

          if (userOrder) {
            toast.success("Order placed successfully");
            if (paymentMethod === "stripe") {
              history.push(`/pay/${userOrder.data}`);
            } else {
              history.push({
                pathname: `/order-review/${userOrder.data}/success`,
                state: { token },
              });
            }
          } else {
            toast.error("Something went wrong");
          }
        }
      } catch (e) {
        toast.error(e);
      }
    }
  };

  const handleSelectLayer = (field) => {
    setSelectedFields((oldFields) =>
      oldFields.includes(field)
        ? oldFields.filter((oldField) => oldField !== field)
        : [...oldFields, field]
    );
  };

  const isChecked = (currentSelectedFields) => {
    const currentSelectedFieldIds =
      (currentSelectedFields &&
        currentSelectedFields?.fields?.map((field) => field?.id)) ||
      [];
    const selectedFieldIds = selectedFields?.map((field) => field?.id);
    const containsAll =
      currentSelectedFieldIds &&
      currentSelectedFieldIds.every((element) => {
        return selectedFieldIds.includes(element);
      });
    return containsAll;
  };

  const checkAllFields = (data) => {
    const selectedFarmField = data?.fields?.map((field) => field?.id);
    let newFields = [];
    if (!isChecked(data)) {
      newFields = [...selectedFields, ...data.fields];
    } else {
      newFields = selectedFields
        .map((field) => {
          if (selectedFarmField.includes(field.id)) {
            return null;
          }
          return field;
        })
        .filter(Boolean);
    }
    setSelectedFields(uniq(newFields));
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    const { value, name } = event.target;
    const newField = { ...formValues, [name]: value };
    setFormValues(newField);
  };

  const handleLearnMore = (product) => {
    setLearnMoreModalOpen(true);
    setLearnMoreContent(
      <div className="more-wrapper">
        <h2 className="title">{product.title}</h2>
        <p className="subtitle">{product?.details?.description}</p>
        <ul className="suggestion-list">
          {product?.details?.suggestion.map((item) => (
            <li className="list-item">
              <CheckCircle color="#09ba51" size={24} /> {item}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const renderOrderCost = () => {
    let orderCost = "";
    if (totalPrice) {
      orderCost =
        `${totalPrice.toLocaleString("en-US", {
          style: "currency",
          currency: "AUD",
          currencyDisplay: "code",
        })}` +
        " " +
        "+ GST";
    }
    if (
      totalPrice === 0 &&
      selectedProduct.title === "2.5m Resolution Imagery"
    ) {
      orderCost = "FREE";
    }
    if (
      totalPrice === 0 &&
      selectedProduct.title !== "2.5m Resolution Imagery"
    ) {
      orderCost = "$0.00 + GST";
    }
    return orderCost;
  };

  const renderProductTiles = (product) => {
    if (product?.title === "Horticulture") {
      return (
        <div
          className={`product-item ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
        >
          <img className="image" src={horticulturePhoto} alt="img" />
          <div className="content">
            <h2 className="title">{product.title}</h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                {product?.config?.captures[0].unit_price_currency} $
                {product?.config?.captures[0].unit_price}.00 minimum per
                hectare. Minimum price of AUD $4000.00, plus GST.
                <br />
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                {product?.config?.captures[0].number_of_captures} Captures
                across 3 months or more.
              </div>
            </div>

            <button
              type="button"
              onClick={() => handleSelectProduct(product)}
              className={`product-button ${
                selectedProduct && selectedProduct.id === product?.id
                  ? "-selected"
                  : ""
              }`}
            >
              {selectedProduct && selectedProduct.id === product?.id
                ? "Selected"
                : "Select"}
            </button>
          </div>
          <div
            className={`action-warning ${
              orderQuotation?.minimum_hectare_requirements_pricing &&
              selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }

    if (product?.title === "Broadacre") {
      return (
        <div
          className={`product-item -broadacre ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
        >
          <img className="image" src={broadacrePhoto} alt="img" />
          <div className="content">
            <h2 className="title">{product.title}</h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                {product?.config?.captures[0].unit_price_currency} $
                {product?.config?.captures[0].unit_price}0 per hectare.
                <br />
                Minimum price of{" "}
                {product?.config?.captures[0].unit_price_currency} $
                {product?.config?.captures[0].min_price}
                .00, plus GST.
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                {product?.unit_min} Hectares minimum.
                <br />
                Up to {product?.config?.captures[0].number_of_captures} Captures
                across 6 weeks.
              </div>
            </div>

            <button
              type="button"
              onClick={() => handleSelectProduct(product)}
              className={`product-button ${
                selectedProduct && selectedProduct.id === product?.id
                  ? "-selected"
                  : ""
              }`}
            >
              {selectedProduct && selectedProduct.id === product?.id
                ? "Selected"
                : "Select"}
            </button>
          </div>
          <div
            className={`action-warning ${
              orderQuotation?.minimum_hectare_requirements_pricing &&
              selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }

    if (product?.title === "Vineyard") {
      return (
        <div
          className={`product-item ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
        >
          <img className="image" src={vineyardPhoto} alt="img" />
          <div className="content">
            <h2 className="title">
              {product.title} <p className="free">(South Australia ONLY)</p>
            </h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                {product?.config?.captures[0].unit_price_currency} $
                {product?.config?.captures[0].unit_price}.00 per hectare.
                <br />
                Minimum price of AU$ {product?.config?.captures[0].min_price}
                .00, plus GST.
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                {product?.config?.captures[0].minimum_cluster_area} Hectares
                minimum.
                <br />
                {product?.config?.captures[0].number_of_captures} Captures
                across 3 months or more.
              </div>
            </div>
            <button
              type="button"
              onClick={() => handleSelectProduct(product)}
              className={`product-button ${
                selectedProduct && selectedProduct.id === product?.id
                  ? "-selected"
                  : ""
              }`}
            >
              {selectedProduct && selectedProduct.id === product?.id
                ? "Selected"
                : "Select"}
            </button>
          </div>
          <div
            className={`action-warning ${
              orderQuotation?.minimum_hectare_requirements_pricing &&
              selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }

    if (product?.title === "Golf & Park") {
      return (
        <div
          className={`product-item ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
        >
          <img className="image" src={golfPhoto} alt="img" />
          <div className="content">
            <h2 className="title">{product.title}</h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                {product?.config?.captures[0].unit_price_currency} $
                {product?.config?.captures[0].min_price}.00 per golf course.
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                All archive captures over a 12 month period (normally 3+ per
                year).
              </div>
            </div>
            <button
              type="button"
              onClick={() => handleSelectProduct(product)}
              className={`product-button ${
                selectedProduct && selectedProduct.id === product?.id
                  ? "-selected"
                  : ""
              }`}
            >
              {selectedProduct && selectedProduct.id === product?.id
                ? "Selected"
                : "Select"}
            </button>
          </div>
          <div
            className={`action-warning ${
              orderQuotation?.minimum_hectare_requirements_pricing &&
              selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }

    if (product?.title === "Tree Crops") {
      return (
        <div
          className={`product-item ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
        >
          <img className="image" src={treesPhoto} alt="img" />
          <div className="content">
            <h2 className="title">{product.title}</h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                {product?.config?.captures[0].unit_price_currency} $
                {product?.config?.captures[0].unit_price.toFixed(2)} per farm
                (fits within 2,500 Ha).
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                {product?.config?.captures[0].number_of_captures} captures over
                3 months.
              </div>
            </div>
            <button
              type="button"
              onClick={() => handleSelectProduct(product)}
              className={`product-button ${
                selectedProduct && selectedProduct.id === product?.id
                  ? "-selected"
                  : ""
              }`}
            >
              {selectedProduct && selectedProduct.id === product?.id
                ? "Selected"
                : "Select"}
            </button>
          </div>

          <div
            className={`action-warning ${
              selectedProduct && selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }

    if (product?.title === "50 cm Resolution Imagery") {
      return (
        <div
          className={`product-item ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
          onClick={() => handleSelectProduct(product)}
          aria-hidden
        >
          <img className="image" src={eightyCMPhoto} alt="img" />
          <div className="content">
            <h2 className="title">{product?.title}</h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                {
                  product?.config?.captures[numOfCaptures]?.unit_price_currency
                }{" "}
                $
                {product?.config?.captures[numOfCaptures]?.unit_price.toFixed(
                  2
                )}{" "}
                per hectare.
                <br />
                Minimum price of{" "}
                {
                  product?.config?.captures[numOfCaptures]?.unit_price_currency
                }{" "}
                ${product?.config?.captures[numOfCaptures]?.min_price}
                .00, plus GST
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                {
                  product?.config?.captures[numOfCaptures]?.minimum_cluster_area
                }{" "}
                Minimum hectares.
              </div>
            </div>
            <div className="custom-capture">
              <div className="input-field">
                <select
                  name="captures"
                  className="input"
                  value={numOfCaptures}
                  onChange={(e) => handleSelectCaptures(e, product)}
                >
                  <option value="" disabled hidden>
                    Select captures
                  </option>
                  {product?.config?.captures.map((capture, index) => (
                    <option key={capture.number_of_captures} value={index}>
                      {capture.number_of_captures}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div
            className={`action-warning ${
              orderQuotation?.minimum_hectare_requirements_pricing &&
              selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }

    if (product?.title === "2.5m Resolution Imagery") {
      return (
        <div
          className={`product-item ${
            selectedProduct && selectedProduct.id === product?.id
              ? "-selected"
              : ""
          }`}
        >
          <img className="image" src={ricePhoto} alt="img" />
          <div className="content">
            <h2 className="title">
              Rice <p className="free">(Free for Australian Rice Farmers)</p>
            </h2>
            <p className="description">{product?.details?.description}</p>
            <button
              className="learn-more"
              type="button"
              onClick={() => handleLearnMore(product)}
            >
              Learn more
            </button>
            <div className="action-bar">
              <div className="price">
                <Tag size={24} color="#292b33" />
                Free
              </div>
              <div className="hectares">
                <FrameCorners size={24} color="#292b33" />
                Limited to Australia only.
                <br />
                {product?.config?.captures[0].number_of_captures} Captures
              </div>
            </div>
            <button
              type="button"
              onClick={() => handleSelectProduct(product)}
              className={`product-button ${
                selectedProduct && selectedProduct.id === product?.id
                  ? "-selected"
                  : ""
              }`}
            >
              {selectedProduct && selectedProduct.id === product?.id
                ? "Selected"
                : "Select"}
            </button>
          </div>
          <div
            className={`action-warning ${
              orderQuotation?.minimum_hectare_requirements_pricing &&
              selectedProduct.id === product?.id
                ? "-visible"
                : ""
            }`}
          >
            Order has been subject to minimum hectare pricing.
          </div>
        </div>
      );
    }
    return null;
  };

  const renderContents = () => {
    if (currentStep === "selectProduct") {
      return (
        <div className="content-wrapper -horizontal">
          <div className="title-wrapper">
            <h2 className="page-title">
              Select a product that suits your crop type
            </h2>
            <h3 className="sub-title">
              Select the type of high resolution imagery product you wish to
              purchase. Imagery products can have different resolutions or may
              be captured once or multiple times in a season.
            </h3>
          </div>
          <div className="product-wrapper" data-testid="product-list">
            {products.map((product) => (
              <>{renderProductTiles(product)}</>
            ))}
          </div>
        </div>
      );
    }

    if (currentStep === "selectDateRange") {
      return (
        <div className="content-wrapper" data-testid="select-date-range">
          <h2 className="page-title">Select date range for your imagery</h2>
          <h3 className="sub-title">
            Please select the start and end date for your imagery order. You
            will recieve an email notification when your order is ready.
          </h3>
          <div className="date-range-picker">
            <div className="input-field">
              <DatePicker
                data-testid="start-date"
                className="input"
                onChange={(date) => handleSelectStartDate(date)}
                popperPlacement="bottom-start"
                dateFormat="dd MMMM yyyy"
                selected={startDate || ""}
                minDate={add(new Date(), { days: 5 })}
              />
              <label className="label">Start Date</label>
            </div>
            <div className="input-field">
              <DatePicker
                data-testid="end-date"
                className="input"
                popperPlacement="bottom-start"
                dateFormat="dd MMMM yyy"
                selected={endDate || ""}
                minDate={add(
                  startDate,
                  selectedProduct?.config?.captures[numOfCaptures]
                    ?.minimum_months %
                    1 !==
                    0
                    ? { days: 42 }
                    : {
                        months:
                          selectedProduct?.config?.captures[numOfCaptures]
                            .minimum_months,
                      }
                )}
                onChange={(date) => handleSelectEndDate(date)}
              />
              <label className="label">End Date</label>
            </div>
          </div>
          <p className="note">
            A minimum of{" "}
            {selectedProduct?.config?.captures[numOfCaptures]?.minimum_months}{" "}
            months applies to this product.
          </p>
        </div>
      );
    }

    if (currentStep === "orderConfirmation") {
      return (
        <div className="content-wrapper">
          <h2 className="page-title">Order Confirmation</h2>
          <h2 className="sub-header">Important Notes</h2>
          <h3 className="sub-title">
            Cloud cover may impact our ability to capture images at the desired
            time. Whilst DataFarming attempts to capture cloud free images,
            there is risk that there will be cloud cover over your property at
            the time of image capture (which is outside of our control).
          </h3>
          <h3 className="sub-title">
            DataFarming aims to capture the selected number of captures. If
            unsuccessful, a partial refund will be given.
          </h3>
          <h3 className="sub-title">
            Typically it takes 10-14 days before a satellite company will start
            capturing images after placing an order (subject to full payment of
            your invoice). It may take several attempts before you receive an
            image.
          </h3>
          <h3 className="sub-title">
            Once a successful capture has occurred, DataFarming will notify the
            user to advise that the imagery is available to view in the
            DataFarming platform.
          </h3>
          <div className="group-divider">
            <span className="icon-image" />
            Farm Details
          </div>
          {selectedFarms && selectedFarms.length > 0
            ? selectedFarms.map((farm) => (
                <div key="farmer-details" className="farm-group">
                  <label className="label">Farm Name</label>
                  <h2 className="farm-name">{farm.properties.farm_name}</h2>
                  <div className="field-selection">
                    <div className="field-header">
                      <p className="column">Field Name</p>
                      <p className="column">Crop Type</p>
                      <p className="column">Area</p>
                    </div>
                    <div className="field-container">
                      {farm.fields.map((field) => (
                        <div
                          className="field-item"
                          onClick={() => handleCheckedFields(field, farm)}
                          aria-hidden
                          data-testid="checkbox-field"
                        >
                          {selectedFields.includes(field) ? (
                            <p className="column" data-testid="selected-field">
                              <span className="icon-check" />
                              {field.properties.field_name}
                            </p>
                          ) : (
                            <p
                              className="column"
                              data-testid="unselected-field"
                            >
                              <span className="circle-empty" />
                              {field.properties.field_name}
                            </p>
                          )}
                          <p className="column">
                            {field.properties?.field_crop_type === ""
                              ? "No Crop Type"
                              : field.properties?.field_crop_type}
                          </p>
                          <p className="column">
                            {`${parseFieldArea(field.properties.area)} Ha`}
                          </p>
                        </div>
                      ))}
                    </div>
                    <div className="options-container">
                      <p className="text">
                        {getFieldCount(farm).fieldCount} Field(s) selected
                      </p>
                      <div className="button-group">
                        <button
                          className="button"
                          type="button"
                          onClick={() => handleRemoveSelectedFarm(farm)}
                        >
                          Remove <span className="icon-trash" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : null}
          <div className="group-divider">
            <span className="icon-receipt" />
            Order Summary
          </div>
          <div className="order-summary">
            <div className="hectares">
              <label className="label">Total Hectares</label>
              {loading ? (
                <DetailsLoader />
              ) : (
                <>
                  <h2 className="text">
                    {parseFieldArea(orderQuotation?.total_product_unit)} Ha
                  </h2>
                </>
              )}
            </div>
            <div className="price">
              <label className="label">Total Price</label>
              {loading ? (
                <DetailsLoader />
              ) : (
                <>
                  <h2 className="text">
                    ${" "}
                    {totalPrice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                    })}
                  </h2>
                </>
              )}
              <label className="extra">Excluding GST</label>
            </div>
          </div>
        </div>
      );
    }

    if (currentStep === "paymentInformation") {
      return (
        <div className="content-wrapper">
          <h2 className="page-title">Payment Information</h2>
          <div className="group-divider">
            <span className="icon-receipt" />
            Personal Details
          </div>
          <div className="input-group">
            <InputField
              label="First Name"
              name="firstName"
              onChange={(e) => setFirstName(e.target.value)}
              value={firstName}
            />
            <InputField
              label="Last Name"
              name="lastName"
              onChange={(e) => setLastName(e.target.value)}
              value={lastName}
            />
          </div>
          <div className="input-group">
            <InputField
              label="Email Address"
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            <InputField
              label="Phone Number"
              name="number"
              onChange={(e) => setNumber(e.target.value)}
              value={number}
            />
          </div>
          <div className="group-divider">
            <span className="icon-receipt" />
            Billing Details
          </div>
          <div className="input-group -solo">
            <InputField
              label="Biller Name/Company Name"
              name=" "
              onChange={(e) => setCompanyName(e.target.value)}
              value={companyName}
            />
          </div>
          <AddressFields
            user={formValues}
            handleSelectCountry={handleSelectCountry}
            handleInputChange={handleInputChange}
            isDisabled={false}
            country={country}
            isOptional
          />
          <div>
            <div className="group-divider">
              <span className="icon-receipt" />
              Payment Method
            </div>
            {selectedProduct?.title === "2.5m Resolution Imagery" ? (
              <div className="payment-method">
                <div>
                  <RadioButton
                    type="radio"
                    value="Invoice"
                    id="invoice"
                    onChange={handlePaymentMethod}
                    name="paymentMethod"
                    label="🎉 Free Imagery - No payment method required"
                    checked
                  />
                </div>
              </div>
            ) : (
              <div className="payment-method">
                <div
                  className={
                    !profile?.payments?.includes("invoice") ? "-disabled" : ""
                  }
                >
                  <RadioButton
                    type="radio"
                    value="Invoice"
                    id="invoice"
                    onChange={handlePaymentMethod}
                    name="paymentMethod"
                    label="Invoice"
                    defaultChecked={totalPrice === 0}
                    checked={paymentMethod === "invoice"}
                    payments={!profile?.payments?.includes("invoice")}
                  />
                </div>
                <RadioButton
                  type="radio"
                  value="Credit or Debit Card"
                  id="stripe"
                  onChange={handlePaymentMethod}
                  name="paymentMethod"
                  label="Credit or Debit Card"
                  defaultChecked={paymentMethod === "stripe"}
                  checked={paymentMethod === "stripe"}
                  hidden={totalPrice === 0}
                />
              </div>
            )}
          </div>
          <label className="terms-checkbox">
            <CheckBox onClick={handleAgreeTerms} checked={agreeTerms} />
            <p>
              I accept the{" "}
              <a
                className="link"
                href={HighResTerms}
                target="_blank"
                rel="noreferrer"
              >
                terms and conditions
              </a>{" "}
              for ordering high resolution imagery from DataFarming.
            </p>
          </label>
        </div>
      );
    }

    return (
      <div className="content-wrapper">
        <h2 className="page-title">Select Farm and Fields</h2>
        <h3 className="sub-title">
          Select farm and fields in order for us to provide information
          regarding the order.
        </h3>
        <div className="group-divider">
          <span className="icon-image" />
          Farm Details
        </div>
        {!selectedFarms.length && (
          <Button
            data-testid="choose-farm-button"
            type="solid"
            color="green"
            label="Choose Farm"
            block
            onClick={() => openFarmsModal()}
          />
        )}
        {selectedFarms.map((farm) => (
          <div
            className={`farm-group ${
              selectedFarmToEdit &&
              selectedFarmToEdit[0].properties.farm_id ===
                farm?.properties.farm_id
                ? "-selected"
                : ""
            }`}
          >
            <label className="label">Farm Name</label>
            <h2 className="farm-name" data-testid="farm-name">
              {farm.properties.farm_name}
            </h2>
            <div
              className={`mapbox-selection ${
                selectedFarmToEdit &&
                selectedFarmToEdit[0].properties.farm_id !==
                  farm?.properties.farm_id
                  ? "-hidden"
                  : ""
              }`}
              data-testid="map-box-container"
            >
              <label className="label">Map Selection</label>
              <div className="mapbox">
                <Map
                  containerStyle={{ height: "240px" }}
                  data={farm}
                  handleSelectLayer={handleSelectLayer}
                  selectedLayers={selectedFields}
                />
              </div>
            </div>
            <div
              className={`field-selection ${
                selectedFarmToEdit &&
                selectedFarmToEdit[0].properties.farm_id !==
                  farm?.properties.farm_id
                  ? "-hidden"
                  : ""
              }`}
              data-testid="field-list"
            >
              <div className="field-header">
                <p className="column check-all">
                  <div
                    data-testid="check-all-fields"
                    className="field-checkbox-header"
                  >
                    <CheckBox
                      onChange={() =>
                        checkAllFields(
                          selectedFarmToEdit && selectedFarmToEdit[0]
                        )
                      }
                      checked={isChecked(
                        selectedFarmToEdit && selectedFarmToEdit[0]
                      )}
                    />
                  </div>
                  <span>Field Name</span>
                </p>
                <p className="column">Crop Type</p>
                <p className="column">Area</p>
              </div>
              <div className="field-container">
                {farm.fields.map((field) => (
                  <div
                    className="field-item"
                    onClick={() => handleCheckedFields(field, farm)}
                    aria-hidden
                    key={field.id}
                  >
                    {selectedFields.includes(field) ? (
                      <p className="column">
                        <span className="icon-check" />
                        {field.properties.field_name}
                      </p>
                    ) : (
                      <p className="column">
                        <span className="circle-empty" />
                        {field.properties.field_name}
                      </p>
                    )}
                    <p className="column">
                      {field.properties?.field_crop_type === ""
                        ? "No Crop Type"
                        : field?.properties?.field_crop_type}
                    </p>
                    <p className="column">
                      {`${parseFieldArea(field.properties.area)} Ha`}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="options-container">
              <p className="text">
                {getFieldCount(farm).fieldCount} Field(s) selected
              </p>
              <div className="button-group">
                {selectedFarms.length > 1 ? (
                  <button
                    className="button"
                    type="button"
                    onClick={() => handleEditState(farm)}
                    data-testid="edit-farm-button"
                  >
                    Edit <span className="icon-edit" />
                  </button>
                ) : null}
                <button
                  className="button"
                  type="button"
                  onClick={() => handleRemoveSelectedFarm(farm)}
                  data-testid="remove-farm-button"
                >
                  Remove <span className="icon-trash" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="highres-ordering">
      <div className="header-panel">
        <span
          className="icon-arrow-left"
          aria-hidden
          onKeyDown={() => history.push("/order")}
          onClick={() => history.push("/order")}
        />
        <span data-testid="high-res-icon" className="icon-image" />
        <h1 data-testid="header" className="title">
          High Resolution Ordering
        </h1>
        <img className="app-logo" src={appLogo} alt="alt" />
      </div>
      <div className="main-container">{renderContents()}</div>
      <div className="sidebar-container">
        <div
          className={
            currentStep === "selectFarmAndFields"
              ? "sidebar-section -selected"
              : "sidebar-section -done"
          }
        >
          <label className="label">
            Selected Farms
            <span
              className={
                currentStep === "selectFarmAndFields"
                  ? "icon-eye"
                  : "icon-check"
              }
            />
          </label>
          <div className="content">
            {selectedFarms &&
              selectedFarms.map((farm) => (
                <div className="text">{farm?.properties.farm_name}</div>
              ))}
          </div>
        </div>
        <div
          className={
            currentStep === "selectProduct"
              ? "sidebar-section -selected"
              : currentStep === "selectFarmAndFields"
              ? "sidebar-section"
              : "sidebar-section -done"
          }
        >
          <label className="label">
            Select Product
            <span
              className={
                currentStep === "selectProduct"
                  ? "icon-eye"
                  : currentStep === "selectFarmAndFields"
                  ? "icon-minus"
                  : "icon-check"
              }
            />
          </label>
          <div className="content">
            <p className="text">{selectedProduct?.title}</p>
          </div>
          <div className="content">
            <label className="timeframe">Total Hectares</label>
            <p className="text">
              {totalHa
                ? parseFieldArea(totalHa)
                : parseFieldArea(selectedFieldsTotalHa)}{" "}
              Ha
            </p>
          </div>
        </div>
        <div
          className={
            currentStep === "selectDateRange"
              ? "sidebar-section -selected"
              : currentStep === "selectFarmAndFields"
              ? "sidebar-section"
              : currentStep === "selectProduct"
              ? "sidebar-section"
              : "sidebar-section -done"
          }
        >
          <label className="label">
            Select Timeframe
            <span
              className={
                currentStep === "selectDateRange"
                  ? "icon-eye"
                  : currentStep === "selectFarmAndFields"
                  ? "icon-minus"
                  : currentStep === "selectProduct"
                  ? "icon-minus"
                  : "icon-check"
              }
            />
          </label>
          <div className="content">
            <label className="timeframe">Start Date</label>
            <p className="text">{formatStartDate}</p>
          </div>
          <div className="content">
            <label className="timeframe">End Date</label>
            <p className="text">{formatEndDate}</p>
          </div>
        </div>
        <div
          className={
            currentStep === "orderConfirmation"
              ? "sidebar-section -selected"
              : currentStep === "selectFarmAndFields"
              ? "sidebar-section"
              : currentStep === "selectProduct"
              ? "sidebar-section"
              : currentStep === "selectDateRange"
              ? "sidebar-section"
              : "sidebar-section -done"
          }
        >
          <label className="label">
            Order Cost
            <span
              className={
                currentStep === "orderConfirmation"
                  ? "icon-eye"
                  : currentStep === "selectFarmAndFields"
                  ? "icon-minus"
                  : currentStep === "selectProduct"
                  ? "icon-minus"
                  : currentStep === "selectDateRange"
                  ? "icon-minus"
                  : "icon-check"
              }
            />
          </label>
          <div className="content">
            {loading ? <DetailsLoader /> : <>{renderOrderCost()}</>}
          </div>
        </div>
        {selectedProduct &&
        selectedProduct.title === "2.5m Resolution Imagery" ? null : (
          <>
            <div
              className={
                currentStep === "paymentInformation"
                  ? "sidebar-section -selected"
                  : currentStep === "selectFarmAndFields"
                  ? "sidebar-section"
                  : currentStep === "selectProduct"
                  ? "sidebar-section"
                  : currentStep === "selectDateRange"
                  ? "sidebar-section"
                  : currentStep === "orderConfirmation"
                  ? "sidebar-section"
                  : "sidebar-section -done"
              }
            >
              <label className="label">
                Payment Method
                <span
                  className={
                    currentStep === "paymentInformation"
                      ? "icon-eye"
                      : currentStep === "selectFarmAndFields"
                      ? "icon-minus"
                      : currentStep === "selectProduct"
                      ? "icon-minus"
                      : currentStep === "selectDateRange"
                      ? "icon-minus"
                      : currentStep === "orderConfirmation"
                      ? "icon-minus"
                      : "icon-check"
                  }
                />
              </label>
              <div className="content">
                {payment === "" ? (
                  <p className="text">Select Payment Method</p>
                ) : (
                  <p className="text">{payment}</p>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="nav-container">
        <Button
          data-testid="exit-to-dashboard-button"
          icon="home"
          label="Exit to dashboard"
          type="outlined"
          color="white"
          prepend
          onClick={() => history.push("/dashboard")}
        />
        {selectedFarms && currentStep === "selectFarmAndFields" ? (
          <Button
            data-testid="include-another-farm-button"
            prepend
            disabled={!selectedFarms.length}
            label="Include Another Farm"
            type="outlined"
            color="white"
            onClick={() => addFarmsModal()}
          />
        ) : (
          <Button
            prepend
            icon="arrow-left"
            label="Previous"
            color="white"
            type="outlined"
            onClick={handleStep}
          />
        )}
        {paymentMethod === "stripe" && currentStep !== "paymentInformation" ? (
          <Button
            data-testid="next-step-button"
            icon="arrow-right"
            label="Next"
            color="blue"
            onClick={() => handleNextButton()}
          />
        ) : (
          ""
        )}
        {paymentMethod === "invoice" && currentStep !== "paymentInformation" ? (
          <Button
            data-testid="next-step-button"
            icon="arrow-right"
            label="Next"
            color="blue"
            onClick={() => handleNextButton()}
          />
        ) : (
          ""
        )}
        {paymentMethod === "stripe" && currentStep === "paymentInformation" ? (
          <Button
            label="Proceed to Payment"
            color="blue"
            disabled={!agreeTerms}
            loading={loading}
            onClick={() => handleSubmitOrder()}
          />
        ) : (
          ""
        )}
        {paymentMethod === "invoice" && currentStep === "paymentInformation" ? (
          <Button
            label="Submit Order"
            color="blue"
            disabled={!agreeTerms}
            loading={loading}
            onClick={() => handleSubmitOrder()}
          />
        ) : (
          ""
        )}
      </div>
      <CustomModal
        isOpen={farmsModalOpen}
        onClose={() => setFarmsModalOpen(false)}
        size="large"
        className="hires-select"
      >
        <h3 className="title">Select Farm</h3>
        <div className="input-field">
          <label htmlFor="searchString" className="label">
            Search farm
          </label>
          <div className="field-wrapper">
            <input
              id="searchString"
              type="text"
              name="searchString"
              className="input"
              onChange={(e) => handleSearchFarm(e.target.value)}
            />
          </div>
        </div>
        <div data-testid="farm-table" className="farm-table">
          <div className="farm-header">
            <p className="column">Farm Name</p>
            <p className="column">No. of Fields</p>
            <p className="column">Total Area</p>
          </div>
          {loading ? (
            <div data-testid="table-loading" className="table-loader">
              <Loading uniqueKey="farms-modal" />
            </div>
          ) : (
            farms?.map((farm) => (
              <>
                {selectedFarms.length &&
                selectedFarms.find(
                  (elem) => elem.properties.farm_id === farm.properties.farm_id
                ) ? (
                  <div
                    className="farm-item -hidden"
                    onClick={() => handleCheckedFarms(farm)}
                    aria-hidden
                    key={farm.id}
                  >
                    <p className="column">
                      <span className="icon-check" />
                      {farm.properties.farm_name}
                    </p>
                    <p className="column">{farm.properties.number_of_fields}</p>
                    <p className="column">
                      {parseFieldArea(farm.properties.farm_area)}
                    </p>
                  </div>
                ) : (
                  <div
                    className={`farm-item ${
                      checkedFarms.length &&
                      !checkedFarms.includes(farm?.properties?.farm_id)
                        ? "-unselected"
                        : ""
                    }`}
                    onClick={() => handleCheckedFarms(farm)}
                    data-testid="check-farm-button"
                    aria-hidden
                  >
                    {checkedFarms?.includes(farm?.properties?.farm_id) ? (
                      <p className="column" data-testid="check-farms">
                        <span className="icon-check" />
                        {farm.properties.farm_name}
                      </p>
                    ) : (
                      <p className="column" data-testid="uncheck-farms">
                        <span className="circle-empty" />
                        {farm.properties.farm_name}
                      </p>
                    )}
                    <p className="column">{farm.properties.number_of_fields}</p>
                    <p className="column">
                      {`${parseFieldArea(farm.properties.farm_area)} Ha`}
                    </p>
                  </div>
                )}
              </>
            ))
          )}
          <div className="pagination-wrapper">
            <div className="pagination-size">
              Show
              <select
                className="select"
                value={currentPageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
              >
                {[5, 10, 15, 20].map((newPageSize) => (
                  <option key={newPageSize} value={newPageSize}>
                    {newPageSize}
                  </option>
                ))}
              </select>
              Items
            </div>

            <div className="main-container">
              <button
                onClick={() => setCurrentPage(0)}
                disabled={currentPage === 0}
                type="button"
                className="first-page"
              >
                First
              </button>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 0}
                type="button"
                className="previous-page"
              >
                <span className="icon-chevron-left" />
                Prev
              </button>
              <span>
                Page{" "}
                <strong>
                  {currentPage + 1} of {pageCount}
                </strong>{" "}
              </span>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === pageCount - 1}
                type="button"
                className="next-page"
              >
                Next
                <span className="icon-chevron-right" />
              </button>
              <button
                onClick={() => setCurrentPage(pageCount - 1)}
                disabled={currentPage === pageCount}
                type="button"
                className="last-page"
              >
                Last
              </button>
            </div>
            <div className="page-number">
              Go to page:{" "}
              <input
                type="number"
                defaultValue={currentPage + 1}
                onChange={(e) => {
                  const targetPage = e.target.value
                    ? Number(e.target.value) - 1
                    : 0;
                  setCurrentPage(targetPage);
                }}
              />
            </div>
          </div>
        </div>
        <Button
          label="Select this farm"
          type="solid"
          color="green"
          data-testid="select-farm-button"
          disabled={!selectedFarmModal}
          onClick={() => handleSelectFarm()}
        />
      </CustomModal>
      <CustomModal
        size="medium"
        isOpen={learnMoreModalOpen}
        onClose={() => setLearnMoreModalOpen(false)}
      >
        {learnMoreContent}
      </CustomModal>
    </div>
  );
};

export default OrderHighResContainer;
